<template>
  <div>
    <div class="container booking-wrapper">
      <div class="row wrapper" v-if="!permissionsError">
        <!-- BOOKING -->
        <section class="col-xl-12 col-12 wrapper-gray">
          <section class="booking-wrapper">
            <section class="booking-title">
              <h4>Запись создана!</h4>
            </section>
            <section class="booking">
              <div class="main-info--wrapper">
                <section class="booking-avatar">
                  <div class="booking-avatar--wrapper"><img :src="getPhotoUrl(professional.photoUrl)" class="avatar" alt=""></div>
                </section>
                <section class="booking-name">
                  <h2>{{professional.name}}</h2>
                  <span class="booking-service--profile">{{professional.profession}}</span>
                </section>
              </div>
              <section class="booking-info">
                <section class="booking-date-service">
                  <section class="booking-service">
                    <span class="booking-service--date-number"></span><br>
                    <span class="booking-service--month"></span>
                  </section>
                  <section class="booking-service--info">
                    <span class="booking-service--service-title">УСЛУГА</span><br>
                    <span class="booking-service--service"></span>
                  </section>
                </section>
                <section class="booking-service--cost">
                  <span></span>
                </section>
              </section>

              <section class="booking-times">
                <div class="booking-times-half1">
                  <div class="time-start"></div>
                  <div class="time-end"></div>
                </div>
                <div class="booking-times-half2">
                  <div class="booking-reminder">
                    <span class="booking-reminder--title">За день до события</span><br>
                    <span class="booking-reminder--hour"></span>
                  </div>
                </div>
              </section>
              <section class="col-xl-12 col-12 wrapper-gray">
                <section class="address">
                  <!-- <div class="address-icon"><img src="/img/address-icon.svg" alt=""></div> -->
                  <div class="address-info">
                    <div class="address-info--wrapper">
                      <h6>АДРЕС</h6>
                      <span>{{address ? address.title : ''}}</span>
                    </div>
                  </div>
                </section>
              </section>

              <section class="buttons no-hide">
                <button v-on:click="UpdateBooking($event)" class="btn button-blue">Редактировать</button>
                <button v-on:click="CancelBooking($event)" class="btn button-gray">Отменить</button>
                <button v-on:click="OpenCalendar($event)" class="btn button-transpend">Открыть календарь</button>
              </section>
            </section>
          </section>
        </section>
        <footer>
          <span>Я согласен с <a href="https://www.myclient.me/terms" target="_blank">Условиями использования</a> <br>и <a href="https://www.myclient.me/terms" target="_blank">Политикой конфиденциальности</a></span>
        </footer>
      </div>
      <div class="row wrapper" v-if="permissionsError">
        <section class="col-xl-12 col-12 wrapper-gray">
          <section class="booking-wrapper error">
            Записи не существует или у вас нет прав для просмотра этой записи.
            <section class="booking">
              <section class="buttons no-hide" style="margin-top: 20px;">
                <button v-on:click="OpenCalendar($event)" class="btn button-transpend">Открыть календарь</button>
              </section>
            </section>
          </section>
        </section>
      </div>
      <section class="popups">
        <div class="popup links-popup">
          <div class="popup-links--wrapper">
            <img src="/img/popup-close.svg" class="close-popup" v-on:click="closePopup($event)" alt="">
            <h2>Через приложение будет быстрее и удобнее</h2>
            <div class="popup-buttons">
              <button v-on:click="getAppLink()">Открыть в приложении</button>
              <span class="close-popup--link"  v-on:click="closePopup($event)">Продолжить в web-версии</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style>
.booking-wrapper .wrapper {
  padding-top: 0px !important;
}

.booking-wrapper.error {
  text-align: center;
  padding: 50px 30px 0 30px;
}

.button-blue, .addeventatc {
  padding: 1rem 0px;
  width: 100%;
  text-align: center;
  background: #2F80ED;
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 36px;
  color: #fff;
  margin-bottom: 1rem;
  color: #fff;
  background-image: none;
}

.button-gray {
  padding: 1rem 0px;
  width: 100%;
  text-align: center;
  background: #C4C4C4;
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 36px;
  color: #fff;
  margin-bottom: 1rem;
}

.button-transpend {
  padding: 1rem 0px;
  width: 100%;
  text-align: center;
  background: transparent;
  backdrop-filter: blur(81.6395px);
  border-radius: 36px;
  color: #2F80ED;
  margin-bottom: 1rem;
  border: 3px solid #2F80ED;
}

.button-blue:active {
  background: #ff9500;
  color: #fff;
}

.no-hide {
  display: block !important;
}

.booking-avatar--wrapper {
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
}

footer {
  padding: 2rem 0px;
  text-align: center;
  background-color: #f6f7fb;
  width: 100%;
}

.popups {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 99999999;
  display: none;
}

.popups .popup {
  position: absolute;
  top: calc(50% - 310px);
  left: calc(50% - 161px);
  width: 320px;
  height: 623px;
  background: linear-gradient(180deg, #A7C3FF 0%, #C3D5FB 54.17%, #A7C3FF 100%);
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.5);
  border-radius: 32px;
}

.popup-links--wrapper {
  overflow: hidden;
  height: 100%;
  background: url(/img/popup/icons.png) no-repeat center 60%
  , url(/img/popup/balloons.png) no-repeat 10% 27%
  , url(/img/popup/phone.png) no-repeat center;
}

.popup-links--wrapper h2 {
  color: #fff;
  font-family: 'Avenir Next Cyr';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  padding: 1rem;
  margin-top: 40px;
  text-align: center;
}

.close-popup--link {
  color: #fff;
  cursor: pointer;
  font-family: 'Avenir Next Cyr';
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  padding: 1rem;
  text-align: center;
  margin-top: 40px;
}

.links-popup button {
  width: 100%;
  text-align: center;
  padding: 1rem;
  background: radial-gradient(42.63% 42.63% at 42.4% 64.39%, #FEB64D 0%, #FF9500 100%);
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 32px;
  color: #fff;
  margin-bottom: 1rem;
  font-family: "Avenir Next Cyr";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.013em;
}

.popup-buttons {
  position: absolute;
  bottom: 1rem;
  text-align: center;
  padding: 1rem;
}

.popup-buttons:after {
  content: "";
  position: absolute;
  top: 0px;
  width: 100px;
  height: 10px;
  background: radial-gradient(57.22% 57.11% at 49.65% 66.17%, #ADADAD 1%, #C0C0C0 7%, #D7D7D7 16%, #E9E9E9 28%, #F6F6F6 41%, #FDFDFD 59%, #FFFFFF 100%);
  background-blend-mode: multiply;
  mix-blend-mode: multiply;
  opacity: 0.62;
  left: calc(50% - 50px);
}

@media screen and (max-width: 320px) {
  .popups .popup {
    width: 300px;
    left: calc(50% - 150px);
  }

  .popup-buttons:after {
    background: transparent;
  }
}

@media screen and (max-height: 650px) {
  .popups .popup {
    height: 500px;
    top: calc(50% - 250px);
  }

  .popup-links--wrapper {
    overflow: hidden;
    height: 100%;
    background: url(/img/popup/phone.png) no-repeat center;
    background-size: 50%;
  }

  .popup-buttons:after {
    background: transparent;
  }
}

@media screen and (max-height: 530px) {
  .popups .popup {
    height: 300px;
    top: calc(50% - 150px);
  }

  .popup-links--wrapper {
    overflow: hidden;
    height: 100%;
    background: url(/img/popup/phone.png) no-repeat center;
    background-size: 40%;
  }

  .popup-links--wrapper {
    background: transparent;
  }
}
</style>

<script>
import Popup from '../components/popup.vue';
import axios from 'axios';
import Header from '../components/header.vue';
import moment from 'moment';

export default {
  name: 'Booking',
  data() {
      return {
        details: {},
        booking: {},
        professional: {},
        servicesList: {},
        address: '',
        permissionsError: false
      };
  },
  metaInfo: {
      title: 'Онлайн-запись',
      titleTemplate: '%s MyClient',
      htmlAttrs: {
          lang: 'ru',
          amp: false
      }
  },
  mounted () {
    let vm = this;
    let auth = location.href.split('auth=')[1];
    if (auth) {
      auth = '?auth=' + auth;
    } else {
      auth = '';
    }
    axios.get(`/api/bookings/${window.bookingId}/details${auth}`).then((response) => {
      const resData = response.data;

      window.professionalId = resData.professionalId;
      vm.details = resData.data;

      if (resData.status && resData.status === 'success' && resData.data) {
        axios.get(`/api/professional/${window.professionalId}/details`).then((response) => {
          const responseData = response.data;
          const data = responseData.data;

          vm.professional = data.profile;
          vm.address = data.address;
          vm.servicesList = data.services;

          let currency = '';
          for(let index in vm.servicesList) {
              let serviceItem = vm.servicesList[index];
              currency = vm.getLocalCurrency(serviceItem.currency);
          }

          setPrice(vm.details.overallCost, currency, vm.details.services);
          $('.booking-reminder--hour').text(vm.details.overallDuration);

          let startDate = moment(vm.details.startDate)
            .add(Math.abs((new Date).getTimezoneOffset()), 'm')
            .toDate();
          let endDate = moment(vm.details.startDate)
            .add((vm.timestrToSec(vm.details.overallDuration)/60 + Math.abs((new Date).getTimezoneOffset())), 'm')
            .toDate();

          $('.booking-service--date-number').text(startDate.getDate());
          $('.booking-service--month').text(vm.months[startDate.getMonth()]);
          $('.time-start').text(
            vm.days[startDate.getDay()] + ' ' + startDate.getHours() + ':' + (startDate.getMinutes() < 10 ? '0' + String(startDate.getMinutes()) : startDate.getMinutes())
          );

          $('.time-end').text(
            vm.days[endDate.getDay()] + ' ' + endDate.getHours() + ':' + (endDate.getMinutes() < 10 ? '0' + String(endDate.getMinutes()) : endDate.getMinutes())
          );

          if(vm.details.services.length === 1) {
            $('.booking-service--service').text(vm.details.services[0].name);
          } else {
            let servicesNames = '';
            for(let j in vm.details.services) {
              let serviceDetailItem = vm.details.services[j];
              servicesNames += serviceDetailItem.name + '<br>';
            }
            $('.booking-service--service').html(servicesNames);
          }

          for(let j in vm.reminderList) {
            let reminder = vm.reminderList[j];
            if(reminder.value === vm.details.reminder.time) {
              $('.booking-reminder--title').text(reminder.title + ' события');
            }
          }
        });
      } else {
        this.$router.push('/form');
      }
    }).catch((e) => {
      if (e.response.status === 401) {
        this.$router.push('/form');
      } else {
        axios.get('/api/auth/check').then((resp) => {
          if (resp.data.status === 'error') {
            this.$router.push('/form');
          } else {
            this.permissionsError = true;
          }
        });
      }
    });

    function setPrice (overallCost, currency, services) {
      let servicesCost = 0,
          currencyStr = (currency ? (' ' + currency) : ''),
          $cost = $('.booking-service--cost');
      (services || []).forEach(it => {
        servicesCost += it.price;
      });
      if (servicesCost === overallCost) {
        $cost.text(vm.details.overallCost + currencyStr);
      } else {
        $cost.html(`
            <div class="old-cost">${servicesCost + currencyStr}</div>
            <div class="new-cost">${Math.round(overallCost) + currencyStr}</div>
        `);
      }
    }
  },
  beforeCreate: function() {
    document.body.className = 'booking';
  },
  methods: {
      getPhotoUrl: function(photoUrl) {
        if( photoUrl !== 'undefined' && photoUrl && /^http/.test(String(photoUrl)) ) {
          return photoUrl;
        }
        else if(photoUrl !== 'undefined' && photoUrl) {
          return 'https://res.cloudinary.com/elmy/image/upload/' + photoUrl;
        }

        return '/img/user.png';
      },
      getAppLink() {
        document.location.href = 'https://www.myclient.me/';
      },
      CancelBooking: function(event) {
        event.preventDefault();

        if(confirm('Вы уверены, что хотите отменить запись?')) {
          let auth = location.href.split('auth=')[1];
          if (auth) {
            auth = '?auth=' + auth;
          } else {
            auth = '';
          }
          axios.post('/api/booking/cancel' + auth, {
            bookingId: window.bookingId
          }).then((response) => {
            localStorage.removeItem('vuex');

            // if(response.data && response.data.status === 'success') {
              this.$store.dispatch('successMessage', 'Букинг удален, вы можете создать новый');
              location.href = '/professional/' + window.professionalId;
            // }
          });
        }
      },
      OpenCalendar (event) {
        location.href = window.calendarUrl;
      },
      closePopup() {
        location.href = 'https://elmy.com/';
      },
      UpdateBooking: function(event) {
        localStorage.removeItem('vuex');

        let vm = this;
        event.preventDefault();

        const details = vm.details;

        if(typeof details.clients !== 'undefined') {
          this.$store.dispatch('username', details.clients[0].name ? details.clients[0].name : '');
          this.$store.dispatch('userphone', details.clients[0].phone ? details.clients[0].phone : '');
          this.$store.dispatch('hour', moment(details.startDate).add(Math.abs((new Date).getTimezoneOffset()), 'm').format('HH:mm'));
          this.$store.dispatch('date', moment(details.startDate).add(Math.abs((new Date).getTimezoneOffset()), 'm').format('YYYY-MM-DD'));
          this.$store.dispatch('datetime', moment(details.startDate).add( Math.abs((new Date).getTimezoneOffset()), 'm' ).format('YYYY-MM-DD HH:mm'));

          this.$store.dispatch('search', details.services[0].id);
          this.$store.dispatch('professionalServicesList', vm.servicesList);

          this.$store.dispatch('sum', details.overallCost);
          this.$store.dispatch('minutes', details.overallDuration);
          this.$store.dispatch('hours', details.overallDuration);
          this.$store.dispatch('client', details.clients);
          this.$store.dispatch('professionalName', details.professional.name);

          let currency = '';
          for(let index in vm.servicesList) {
              let serviceItem = vm.servicesList[index];

              currency = serviceItem.currency//vm.getLocalCurrency(serviceItem.currency);
          }
          this.$store.dispatch('currency', currency);

          for(let index in details.services) {
            let service = details.services[index];

            this.$store.dispatch('services', {
              keyName: service.id,
              value: true,
            });
          }

          for(let j in vm.reminderList) {
            let reminder = vm.reminderList[j];

            if(reminder.value === details.reminder.time) {
              this.$store.dispatch('reminder', j);
            }
          }

          location.href = '/booking/' + window.bookingId + '#/';
          location.reload();
        }
      },
      discount(price, service) {
        let total = parseFloat(price);

        if(service && typeof service.discount !== 'undefined' && service.discount) {
          let discount = service.discount;
          if(discount.percent > 0 && total > 0) {
            let percent = parseFloat(discount.percent);
            if(percent) {
              let discountSum = total * (percent / 100);

              total = total - discountSum;
            }
          }
        }

        return Math.round(total);
      },
      parseTimeToMinutes(time) {
        time = String(time);
        time = time.replace(':', '');

        return Number(time);
      },
      getTimeFromMins(mins) {
        let num = mins;
        let hours = (num / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);

        return (rhours < 10 ? '0' : '' ) + rhours + ":" + rminutes;
      },
      timestrToSec(timestr) {
        var parts = timestr.split(":");
        return (parts[0] * 3600) +
              (parts[1] * 60);
      },
      pad(num) {
        if(num < 10) {
          return "0" + num;
        } else {
          return "" + num;
        }
      },
      formatTime(seconds) {
        return [this.pad(Math.floor(seconds/3600)),
                this.pad(Math.floor(seconds/60)%60),
                ].join(":");
      },

      getStartTime() {

      },
      getEndTime() {

      },
      getTimezone() {

      },
      getTitle() {

      },
      getDescription() {

      },
      getAddress() {

      },
      getLocalCurrency(curr) {
        return typeof this.currenciesLocal[curr] !== 'undefined'
          ? this.currenciesLocal[curr]
          : curr;
      },
  },
  components: {
    Header,
    Popup
  },
  computed: {
    startsCount() {
      return this.$store.getters.startsCount;
    },
    username() {
      return this.$store.getters.username;
    },
    userphone() {
      return this.$store.getters.userphone;
    },
    hour() {
      return this.$store.getters.hour;
    },
    date() {
      return this.$store.getters.date;
    },
    search() {
      return this.$store.getters.search;
    },
    professionalId() {
      return this.$store.getters.professionalId;
    },
    professionalName() {
      return this.$store.getters.professionalName;
    },
    bookingId() {
      return this.$store.getters.bookingId;
    },
    client() {
      return this.$store.getters.client;
    },
    reminder() {
      let title = 'За день до';
      let check = false;

      for(let index in this.reminderList) {
        let item = this.reminderList[index];

        if(item.id === this.$store.getters.reminder) {

          check = true;
          title = item.title;
          break;
        }
      }

      return title;
    },
     days() {
      return this.$store.getters.days;
    },
    months() {
      return this.$store.getters.months;
    },
    reminderList() {
      return this.$store.getters.reminderList;
    },
    currenciesLocal() {
      return this.$store.getters.currenciesLocal;
    }
  },
};
</script>
